import OtpVerificationFunctional from './index.function';
import AuthContainer from '../../components/AuthContainer';
import ViewReverse from '../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { Button, ConfirmModal, InputField, Text } from '../../components/SecondaryMarket';
import { COLORS, fontSizes } from '../../constants/constants';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { numeric_integer_regix } from '../../utils/functions';

const OtpVerification = () => {
  const {
    TextWeight,
    navigate,
    timerKey,
    timer,
    otp,
    setOtp,
    verifyOtp,
    resumeModal,
    setResumeModal,
    sendOtpLoading,
    resendOtp,
    getContentKey,
    isResendCode,
    setIsResendCode,
    verifyOtpLoading,
    handleDiscard,
    handleResume
  } = OtpVerificationFunctional();


  const timerCount = ({ remainingTime }) => {
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;

    return (
      <Text
        text={`${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`}
        size={fontSizes.h23}
        weight={TextWeight.light}
        className={'text-dark-blue'}
      />
    );
  };

  return (
    <AuthContainer className={'px-8'}>
      <ViewReverse className={'items-center gap-3 cursor-pointer'} onClick={() => navigate(-1)}>
        <ReactSVG src={icons.back} />
        <Text text={getContentKey("back")} className={'text-text-grey mt-0.5'} />
      </ViewReverse>

      <Text text={getContentKey("create_new_account")} weight={TextWeight.headingRegular} className={'text-dark-blue mt-10 mb-9'} size={fontSizes.h30} />

      <div className='w-full p-5 shadow-lg rounded-lg'>
        <Text text={getContentKey("otp_send_msg")} size={fontSizes.h14} weight={TextWeight.medium} />

        <div className='my-4 flex justify-center'>
          <CountdownCircleTimer
            key={timerKey}
            isPlaying={true}
            duration={timer}
            colors={[COLORS.dark_blue]}
            strokeWidth={4}
            size={90}
            trailColor='#D9D8D5'
            strokeLinecap='round'
            rotation='counterclockwise'
            onComplete={(e) => {
              setIsResendCode(true)
            }}
          >
            {timerCount}
          </CountdownCircleTimer>
        </div>

        <InputField isRequired placeholder={getContentKey("enter_otp")} value={otp} maxLength={4} className={'border-0 border-b rounded-none'}
          onChange={(e) => {
            if(numeric_integer_regix.test(e)){
              setOtp(e)
            }
          }}
           />

        <ViewReverse className={'gap-2 mt-5'}>
          <Button
            text={getContentKey("resend_otp")}
            isDisabled={sendOtpLoading || !isResendCode}
            className={'w-full bg-white text-black border border-grey'}
            textSize={fontSizes.h14}
            onClick={resendOtp}
          />
          <Button
            text={getContentKey("confirm_otp")}
            isDisabled={sendOtpLoading || isResendCode || verifyOtpLoading}
            className={'w-full'}
            textSize={fontSizes.h14}
            loading={verifyOtpLoading}
            onClick={verifyOtp}
          />
        </ViewReverse>
      </div>

      <ConfirmModal
        isOpen={resumeModal}
        title={getContentKey("resume_your_application")}
        descOne={getContentKey("continue_where_left")}
        icon={icons.info}
        leftBtn={getContentKey("cancel")}
        rightBtn={getContentKey("continue_application")}
        onClose={() => setResumeModal(false)}
        // onLeftPress={() => setResumeModal(false)}
        onLeftPress={handleDiscard}
        onRightPress={handleResume}
      />
    </AuthContainer>
  );
};

export default OtpVerification;
